
import Vue from 'vue'
import Vuex from 'vuex'
import wLogo from '../assets/logoWith.png'
import logo from '../assets/logo.png'
import { sessionGetUserInfo, sessionSetUserInfo } from "@/assets/js/utils.session";
import {getWebHref, parseUrlParams} from "../assets/js/utils";
import ca from "element-ui/src/locale/lang/ca";
Vue.use(Vuex)

function getUrlUserInfo(){
  const params = parseUrlParams();
  console.log('getUrlUserInfo:', params)
  const key = params.U;
  if(!key) return false
  const str = localStorage.getItem(key);
  let data = false;
  if(str){
    try {
      data = JSON.parse(str);
      localStorage.removeItem(key);
    }catch (e) {
     console.warn("解析携带用户信息异常",key);
     console.error(e);
    }
  }
  return data;
}

const state = {
  Authorization: getUrlUserInfo() || sessionGetUserInfo(),
  tag: 1,
  setType: false,
  activeType: 1,
  logo: wLogo,
  payVisible: false,
  logoType: true,
  loginShow: false,
  isShow: false, // 调用查询轨迹引导
  dialogShow: false,//首页是否显示扫码绑定微信账号
  isCover: false,
  stateTagsList: [],// 当前点击的路由标签数组
  webHref:getWebHref(),
  bannerList: [],
  isOpen: false,
  /**
   * 顶部栏背景色
   * 1=主题色 2=白色
   */
  headType: 1
};
const mutations = {
  changeloginShow(state, data) {
    state.loginShow = data
  },
  changeLogoshow(state, data) {
    state.logoType = data
  },
  changepayTypeshow(state, data) { //因首页banner需要直接打开个人中心 充值弹窗 更改充值展示及隐藏
    state.payVisible = data
  },
  addUserdata(state, data) { // 修改用户登录信息
    state.Authorization = data
    sessionSetUserInfo(data)
  },
  changeSetType(state, data) {
    // console.log('setType',data)
    state.setType = data
    if (data) {
      state.logo = logo
    } else {
      state.logo = wLogo
    }

  },
  changeHeadType(state, data) {
    state.headType = data
  },
  changeactive(state, data) {
    state.activeType = data
  },
  changDialogShow(state, data) { //
    state.dialogShow = data
  },
  mutationSelectTags(state, data) { //保存路由标签
    let result = false
    for (let i = 0; i < state.stateTagsList.length; i++) {
      if (state.stateTagsList[i].code == data.code) {
        return result = true
      }
    }
    result === false ? state.stateTagsList.push(data) : ''
  },
  /**
 * 关闭tag标签
 */
  mutationCloseTag(state, data) {
    let result = state.stateTagsList.findIndex(item => item.code == data.code)
    state.stateTagsList.splice(result, 1)
  },
  // 清空标签、关闭其他
  emptyList(state, data) {
    state.stateTagsList.splice(0, state.stateTagsList.length)
    if(data){//关闭其他
      state.stateTagsList.push(data)
    }
  },
  setBannerList(state, data) {
    state.bannerList = data
  },
  changeIsOpen(state, data) {
    state.isOpen = data
  }
}
const getters = {
  customerId: state => {
    let obj = state.Authorization || {};
    return obj.customerid || '';
  },
  token: state => {
    let obj = state.Authorization || {};
    return obj.token || '';
  },
  // 实名认证类型 1：销售代理认证 2：分销大使认证，3：省代 4：产业带加盟商 5：专线/分段供应商入驻  6:城市合伙人 7:货代询价用户 -1:都可以选择
  realNameType:state=>{
    let obj = state.Authorization || {};
    let authenticationInfoDTO = obj.authenticationInfoDTO||{};
    return authenticationInfoDTO.type || -1;
  },
  // 实名认证状态 -1 未认证 1：已提交相关资料，审核中 2：认证失败 3：已认证
  realNameState:state=>{
    let obj = state.Authorization || {};
    let authenticationInfoDTO = obj.authenticationInfoDTO||{};
    return authenticationInfoDTO.state || -1;
  },
  // 合伙人认证类型 1:公司 2:个人
  authenticationType:state=>{
    let obj = state.Authorization || {};
    let authenticationInfoDTO = obj.authenticationInfoDTO||{};
    return authenticationInfoDTO.authenticationType || -1;
  },
  isInquiryUserSuccess: state=> {
    let obj = state.Authorization || {};
    let authenticationInfoDTO = obj.authenticationInfoDTO||{};
    return authenticationInfoDTO.isInquiryUserSuccess || false;
  },
  // 首页banner
  homePageBanner:state => {
    return state.bannerList.filter(item => item.applicationpage === 0)
  },
  // 平台介绍页banner
  platformIntroduceBanner:state => {
    return state.bannerList.filter(item => item.applicationpage === 1)
  },
  // 平台入驻banner
  platformSettledBanner:state => {
    return state.bannerList.filter(item => item.applicationpage === 2)
  }
}
export default new Vuex.Store({
  state,
  mutations,
  getters
});



// WEBPACK FOOTER //
// ./src/store/index.js